module.exports = __webpack_public_path__ + "img/iconai.d99066de.png";